import {
  CHECKLIST_TEMPLATE_LIST_ACTIVE,
  CHECKLIST_TEMPLATE_LIST_ACTIVE_SUCCESS,
  CHECKLIST_TEMPLATE_LIST_ACTIVE_FAILURE,
  CHECKLIST_TEMPLATE_ASSIGN_TO_TASK,
  CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_SUCCESS,
  CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_FAILURE,
  CHECKLIST_SEARCH,
  CHECKLIST_SEARCH_SUCCESS,
  CHECKLIST_SEARCH_FAILURE,
  CHECKLIST_DATA,
  CHECKLIST_DATA_SUCCESS,
  CHECKLIST_DATA_FAILURE,
  CHECKLIST_UPDATE,
  CHECKLIST_UPDATE_SUCCESS,
  CHECKLIST_UPDATE_FAILURE,
  CHECKLIST_PDF_SHEET,
  CHECKLIST_PDF_SHEET_SUCCESS,
  CHECKLIST_PDF_SHEET_FAILURE,
  DELETE_TASK_CHECKLIST,
  DELETE_TASK_CHECKLIST_SUCCESS,
  DELETE_TASK_CHECKLIST_FAILURE,
  CHECKLIST_MERGE_WITH_TEMPLATE,
  CHECKLIST_MERGE_WITH_TEMPLATE_SUCCESS,
  CHECKLIST_MERGE_WITH_TEMPLATE_FAILURE,
  TASK_CHECKLIST_SEARCH,
  TASK_CHECKLIST_SEARCH_SUCCESS,
  TASK_CHECKLIST_SEARCH_FAILURE,
  TASK_CHECKLIST_LIST,
  TASK_CHECKLIST_LIST_SUCCESS,
  TASK_CHECKLIST_LIST_FAILURE,
  CHECKLIST_PDF_SHEET_DEBUG,
  CHECKLIST_PDF_SHEET_DEBUG_SUCCESS,
  CHECKLIST_PDF_SHEET_DEBUG_FAILURE,
  CREATE_CHECKLIST_TEMPLATE,
  CREATE_CHECKLIST_TEMPLATE_SUCCESS,
  CREATE_CHECKLIST_TEMPLATE_FAILURE,
  UPDATE_CHECKLIST_TEMPLATE,
  UPDATE_CHECKLIST_TEMPLATE_SUCCESS,
  UPDATE_CHECKLIST_TEMPLATE_FAILURE,
  CLONE_CHECKLIST_TEMPLATE,
  CLONE_CHECKLIST_TEMPLATE_SUCCESS,
  CLONE_CHECKLIST_TEMPLATE_FAILURE,
  CHECKLIST_TEMPLATE_DATATYPE_LIST,
  CHECKLIST_TEMPLATE_DATATYPE_LIST_SUCCESS,
  CHECKLIST_TEMPLATE_DATATYPE_LIST_FAILURE,
  CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST,
  CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_SUCCESS,
  CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_FAILURE,
  CHECKLIST_TEMPLATE_PDFTHEME_LIST,
  CHECKLIST_TEMPLATE_PDFTHEME_LIST_SUCCESS,
  CHECKLIST_TEMPLATE_PDFTHEME_LIST_FAILURE,
} from "./actionType";

// CheckList Template List Active
export const checkListTemplateListActive = () => {
  return {
    type: CHECKLIST_TEMPLATE_LIST_ACTIVE,
  };
};

export const checkListTemplateListActiveSuccess = (data) => {
  return {
    type: CHECKLIST_TEMPLATE_LIST_ACTIVE_SUCCESS,
    payload: data,
  };
};

export const checkListTemplateListActiveFailure = (error) => {
  return {
    type: CHECKLIST_TEMPLATE_LIST_ACTIVE_FAILURE,
    payload: error,
  };
};

// CheckList Template Assign To Task
export const checkListTemplateAssignToTask = (data) => {
  return {
    type: CHECKLIST_TEMPLATE_ASSIGN_TO_TASK,
    payload: data,
  };
};

export const checkListTemplateAssignToTaskSuccess = (data) => {
  return {
    type: CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_SUCCESS,
    payload: data,
  };
};

export const checkListTemplateAssignToTaskFailure = (error) => {
  return {
    type: CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_FAILURE,
    payload: error,
  };
};

// CheckList Search
export const checkListSearch = (data) => {
  return {
    type: CHECKLIST_SEARCH,
    payload: data,
  };
};

export const checkListSearchSuccess = (data) => {
  return {
    type: CHECKLIST_SEARCH_SUCCESS,
    payload: data,
  };
};

export const checkListSearchFailure = (error) => {
  return {
    type: CHECKLIST_SEARCH_FAILURE,
    payload: error,
  };
};

// CheckList Data
export const checkListData = (data) => {
  return {
    type: CHECKLIST_DATA,
    payload: data,
  };
};

export const checkListDataSuccess = (data) => {
  return {
    type: CHECKLIST_DATA_SUCCESS,
    payload: data,
  };
};

export const checkListDataFailure = (error) => {
  return {
    type: CHECKLIST_DATA_FAILURE,
    payload: error,
  };
};

// CheckList Update
export const checkListUpdate = (data) => {
  return {
    type: CHECKLIST_UPDATE,
    payload: data,
  };
};

export const checkListUpdateSuccess = (data) => {
  return {
    type: CHECKLIST_UPDATE_SUCCESS,
    payload: data,
  };
};

export const checkListUpdateFailure = (error) => {
  return {
    type: CHECKLIST_UPDATE_FAILURE,
    payload: error,
  };
};

// CheckList PDF Sheet
export const checkListPdfSheet = (data) => {
  return {
    type: CHECKLIST_PDF_SHEET,
    payload: data,
  };
};

export const checkListPdfSheetSuccess = (data) => {
  return {
    type: CHECKLIST_PDF_SHEET_SUCCESS,
    payload: data,
  };
};

export const checkListPdfSheetFailure = (error) => {
  return {
    type: CHECKLIST_PDF_SHEET_FAILURE,
    payload: error,
  };
};

// Delete Task CheckList
export const deleteTaskCheckList = (data) => {
  return {
    type: DELETE_TASK_CHECKLIST,
    payload: data,
  };
};

export const deleteTaskCheckListSuccess = (data) => {
  return {
    type: DELETE_TASK_CHECKLIST_SUCCESS,
    payload: data,
  };
};

export const deleteTaskCheckListFailure = (error) => {
  return {
    type: DELETE_TASK_CHECKLIST_FAILURE,
    payload: error,
  };
};

// CheckList Merge With Template
export const checkListMergeWithTemplate = (data) => {
  return {
    type: CHECKLIST_MERGE_WITH_TEMPLATE,
    payload: data,
  };
};

export const checkListMergeWithTemplateSuccess = (data) => {
  return {
    type: CHECKLIST_MERGE_WITH_TEMPLATE_SUCCESS,
    payload: data,
  };
};

export const checkListMergeWithTemplateFailure = (error) => {
  return {
    type: CHECKLIST_MERGE_WITH_TEMPLATE_FAILURE,
    payload: error,
  };
};

// Task CheckList Search
export const taskCheckListSearch = (data) => {
  return {
    type: TASK_CHECKLIST_SEARCH,
    payload: data,
  };
};

export const taskCheckListSearchSuccess = (data) => {
  return {
    type: TASK_CHECKLIST_SEARCH_SUCCESS,
    payload: data,
  };
};

export const taskCheckListSearchFailure = (error) => {
  return {
    type: TASK_CHECKLIST_SEARCH_FAILURE,
    payload: error,
  };
};

// Task CheckList List
export const taskCheckListList = () => {
  return {
    type: TASK_CHECKLIST_LIST,
  };
};

export const taskCheckListListSuccess = (data) => {
  return {
    type: TASK_CHECKLIST_LIST_SUCCESS,
    payload: data,
  };
};

export const taskCheckListListFailure = (error) => {
  return {
    type: TASK_CHECKLIST_LIST_FAILURE,
    payload: error,
  };
};

// CheckList PDF Sheet Debug
export const checkListPdfSheetDebug = (data) => {
  return {
    type: CHECKLIST_PDF_SHEET_DEBUG,
    payload: data,
  };
};
export const checkListPdfSheetDebugSuccess = (data) => {
  return {
    type: CHECKLIST_PDF_SHEET_DEBUG_SUCCESS,
    payload: data,
  };
};
export const checkListPdfSheetDebugFailure = (error) => {
  return {
    type: CHECKLIST_PDF_SHEET_DEBUG_FAILURE,
    payload: error,
  };
};

// Create CheckList Template
export const createCheckListTemplate = (data) => {
  return {
    type: CREATE_CHECKLIST_TEMPLATE,
    payload: data,
  };
};
export const createCheckListTemplateSuccess = (data) => {
  return {
    type: CREATE_CHECKLIST_TEMPLATE_SUCCESS,
    payload: data,
  };
};
export const createCheckListTemplateFailure = (error) => {
  return {
    type: CREATE_CHECKLIST_TEMPLATE_FAILURE,
    payload: error,
  };
};

// Update CheckList Template
export const updateCheckListTemplate = (data) => {
  return {
    type: UPDATE_CHECKLIST_TEMPLATE,
    payload: data,
  };
};
export const updateCheckListTemplateSuccess = (data) => {
  return {
    type: UPDATE_CHECKLIST_TEMPLATE_SUCCESS,
    payload: data,
  };
};
export const updateCheckListTemplateFailure = (error) => {
  return {
    type: UPDATE_CHECKLIST_TEMPLATE_FAILURE,
    payload: error,
  };
};

// Clone CheckList Template
export const cloneCheckListTemplate = (data) => {
  return {
    type: CLONE_CHECKLIST_TEMPLATE,
    payload: data,
  };
};
export const cloneCheckListTemplateSuccess = (data) => {
  return {
    type: CLONE_CHECKLIST_TEMPLATE_SUCCESS,
    payload: data,
  };
};
export const cloneCheckListTemplateFailure = (error) => {
  return {
    type: CLONE_CHECKLIST_TEMPLATE_FAILURE,
    payload: error,
  };
};

// CheckList Template DataType List
export const checkListTemplateDataTypeList = () => {
  return {
    type: CHECKLIST_TEMPLATE_DATATYPE_LIST,
  };
};
export const checkListTemplateDataTypeListSuccess = (data) => {
  return {
    type: CHECKLIST_TEMPLATE_DATATYPE_LIST_SUCCESS,
    payload: data,
  };
};
export const checkListTemplateDataTypeListFailure = (error) => {
  return {
    type: CHECKLIST_TEMPLATE_DATATYPE_LIST_FAILURE,
    payload: error,
  };
};

// CheckList Template System Field List
export const checkListTemplateSystemFieldList = () => {
  return {
    type: CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST,
  };
};
export const checkListTemplateSystemFieldListSuccess = (data) => {
  return {
    type: CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_SUCCESS,
    payload: data,
  };
};
export const checkListTemplateSystemFieldListFailure = (error) => {
  return {
    type: CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_FAILURE,
    payload: error,
  };
};

// CheckList Template PDF Theme List
export const checkListTemplatePdfThemeList = () => {
  return {
    type: CHECKLIST_TEMPLATE_PDFTHEME_LIST,
  };
};
export const checkListTemplatePdfThemeListSuccess = (data) => {
  return {
    type: CHECKLIST_TEMPLATE_PDFTHEME_LIST_SUCCESS,
    payload: data,
  };
};
export const checkListTemplatePdfThemeListFailure = (error) => {
  return {
    type: CHECKLIST_TEMPLATE_PDFTHEME_LIST_FAILURE,
    payload: error,
  };
};
